import React, { useEffect }  from 'react'
import { Button } from 'antd';
import FAQ from './FAQ'

import { Link } from "react-router-dom";

export default function Dilemma(props) {
    useEffect(() => {
        document.title = "Vabis' Literature Services - Literature Proofreading - Writer's dilemma";
        window.scrollTo(0, 0);
    }, [])

    return (
         <div className="App">
             <div className="promotion">&#128218;&#128218;  CLAIM 10 PERCENT OFF NOW USING CODE: <b>10OFF</b> , USE IT ON PAYMENT PAGE  &#128218;&#128218;</div>
             <div className="header-wrapper">
                 <img
                     src={'/images/shutterstock_233964439_600.jpg'}
                     srcSet={`/images/shutterstock_233964439_1200.jpg 4000w`}
                     alt="Writer's dilemma"
                     style={{float: 'left', width: '100%'}}
                 />

                 <div className="header-text">
                     <header>
                         <h1>Writer's Dilemma</h1>
                     </header>
                     <p>
                         How many times have you second-guessed if the character development is neat or if the plot has a sound congruency to it? Your time to fret over: “what will my potential readers think about this and that”, is over! Having formally studied literature and being a life-long bookworm makes me a seasoned reader. Thus, I shall help you put your doubts about plot and/or character development at ease. Moreover, I shall also help you write a title for your book. After all, a catchy title will draw potential readers attention to your book. I shall also help evaluate character names, chapter name and title appropriateness, all for an affordable price.
                     </p>
                     <Link to="/request?service=dilemma"><Button type="primary">Request to resolve Writer's Dilemma</Button></Link>
                 </div>
             </div>
             <div className="content-wrapper">
                 <FAQ topic='dilemma'/>
                 <FAQ topic='general' />
             </div>
         </div>
    )
}
